// Formatting + status helpers for the admin Usage tab (components/UsageTab.jsx).

const GIB = 2 ** 30;

export function fmtCount(n) {
  if (n == null || !Number.isFinite(Number(n))) return '—';
  const v = Number(n);
  if (Math.abs(v) >= 1e9) return `${(v / 1e9).toFixed(1)}B`;
  if (Math.abs(v) >= 1e6) return `${(v / 1e6).toFixed(1)}M`;
  if (Math.abs(v) >= 1e4) return `${Math.round(v / 1e3)}k`;
  return v.toLocaleString('en-US');
}

export function fmtGiB(bytes) {
  if (bytes == null || !Number.isFinite(Number(bytes))) return '—';
  const g = Number(bytes) / GIB;
  return g >= 100 ? `${Math.round(g).toLocaleString('en-US')} GiB` : `${g.toFixed(1)} GiB`;
}

export function fmtUsd(n) {
  if (n == null || !Number.isFinite(Number(n))) return '—';
  return `$${Number(n).toFixed(2)}`;
}

// Latest non-null storage value per field (backups only report on change).
export function latestStorage(days = []) {
  const out = { dataBytes: null, pitrBytes: null, backupBytes: null };
  for (const k of Object.keys(out)) {
    for (let i = days.length - 1; i >= 0; i--) {
      if (days[i] && days[i][k] != null) { out[k] = days[i][k]; break; }
    }
  }
  return out;
}

// { ok, detail } from snapshot.orphans: { coll: { parents, orphanParents } | { error } }.
export function orphanStatus(orphans) {
  const entries = Object.entries(orphans || {});
  if (!entries.length) return { ok: false, detail: 'Not checked yet.' };
  const errored = entries.filter(([, v]) => v && v.error);
  const total = entries.reduce((s, [, v]) => s + ((v && v.orphanParents) || 0), 0);
  const parts = entries.map(([k, v]) => (v && v.error ? `${k}: check failed` : `${k}: ${v.orphanParents} of ${v.parents} parents`));
  if (total > 0) return { ok: false, detail: `${total} market parents deleted with odds rows left behind. ${parts.join(' · ')}` };
  if (errored.length) return { ok: false, detail: parts.join(' · ') };
  return { ok: true, detail: parts.join(' · ') };
}

// snapshot.freeze_mode is null when the backend couldn't read the freeze flag.
export function freezeLabel(freezeMode) {
  if (freezeMode === true) return 'Freeze ON';
  if (freezeMode === false) return 'Live';
  return 'Freeze unknown';
}
